// Id яндекс метрики
export const YANDEX_METRIC_ID = 88964020;
